import { useSiteI18n } from '../i18n/siteI18n';

export default function TopToolbar({ showBack = false, onBack }) {
  const { lang, setLang, t, languageOptions } = useSiteI18n();

  return (
    <div className="App-site-toolbar">
      <div className="App-site-toolbar-left">
        {showBack ? (
          <button
            type="button"
            className="App-back-button"
            onClick={onBack}
            aria-label={t('backToHome')}
            title={t('backToHome')}
          >
            <img src="/img/back.svg" className="App-back-icon" alt="" aria-hidden="true" />
          </button>
        ) : (
          <span className="App-toolbar-spacer" aria-hidden="true" />
        )}
      </div>

      <div className="App-site-lang-controls" aria-label="Language switcher">
        <label className="App-site-lang-label" htmlFor="site-lang-select">
          {t('languageLabel')}
        </label>
        <select
          id="site-lang-select"
          className="App-site-lang-select"
          value={lang}
          onChange={(event) => setLang(event.target.value)}
        >
          {languageOptions.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
}
